export const FormSamplesDifferentControlsPageInfo = () => {
    return (
        <>
            This shows the different types of controls the project currently supports.<br />
            It is very easy to create your own control and use it within the form, see the Custom Control example
            for more information.
        </>
    )
}
